import { connect } from 'react-redux'
import { Map, List } from 'immutable'

import { onChange, onBatchChange, init, onSubmit, resetForm, setMeta } from './actions'

import Validator from './Validator'

export default function connectForm(formId, component, mapStateToProps, mapDispatchToProps) {
  function formMapStateToProps(state) {
    let data = state.formData.get(formId, Map())
    let props = typeof mapStateToProps === 'function' ? mapStateToProps(state) || {} : {}
    props.formState = {
      errors: data.get('errors', Map()),
      messages: data.get('messages', List()),
      values: data.get('values', Map()),
      originalValues: data.get('originalValues', Map()),
      changed: data.get('changed', Map()),
      meta: data.get('meta', Map()).toJS(),
      loading: data.get('loading', false),
    }

    return props
  }

  function formMapDispatchToProps(dispatch) {
    let props = typeof mapDispatchToProps === 'function' ? mapDispatchToProps(dispatch) || {} : {}

    // Handle value update
    props.formUpdate = (data, batch = false) => {
      batch === true ? dispatch(onBatchChange(formId, data)) : dispatch(onChange(formId, data))
    }

    props.formInit = values => {
      dispatch(init(formId, values))
    }

    props.formReset = () => {
      dispatch(resetForm(formId))
    }

    props.formSetMeta = meta => {
      dispatch(setMeta(formId, meta))
    }

    // Handle form submit
    props.handleSubmit = ({ values, changed, meta }, context = {}) => {
      function handleSubmitDispatch(dispatch) {
        let { formSubmit, formValidation = {} } = component

        let validation = false

        if (typeof formValidation === 'function') {
          validation = formValidation.call(this, values, changed, meta, context)
        } else if (typeof formValidation === 'object') {
          validation = formValidation
        }

        let errors = validation ? Validator(values, validation) : Map()

        if (!errors.size) {
          dispatch({
            type: 'FORM_SUBMIT_LOADING',
            formId,
            loading: true,
          })

          formSubmit(dispatch, formId, values, changed, meta, context)
        } else {
          dispatch({
            type: 'FORM_SUBMIT_VALIDATION_ERROR',
            formId,
            errors,
          })
        }
      }

      dispatch(handleSubmitDispatch)
    }

    return props
  }

  function formMergeProps(stateProps, dispatchProps, ownProps) {
    return Object.assign({}, ownProps, stateProps, dispatchProps, {
      formSubmit: (context = {}) => dispatchProps.handleSubmit(stateProps.formState, context),
    })
  }

  return connect(formMapStateToProps, formMapDispatchToProps, formMergeProps)(component)
}
